import React, { Component, Fragment } from 'react'
import { Container,Row,Col, Form,Button } from 'react-bootstrap'

import validation from '../../validation/validation';
import axios from 'axios' 
import AppURL from '../../api/AppURL';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

 

export class NewsletterSubscribe extends Component {

       componentDidMount(){
          window.scroll(0,0)
     }
     
constructor(){
          super();
          this.state={
                        email:""       

          }
     }
         emailOnChange =(event)=>{
               let email = event.target.value;
               // alert(email);
               this.setState({email:email})
          }
        
          onFormSubmit =(event)=>{
         
               let email = this.state.email;
       
               let sendBtn = document.getElementById('sendBtn');
               let subscribeForm = document.getElementById('subscribeForm');

               if(email.length==0){
                    
                    toast.error("Please put your Email");
               }

               else{
     sendBtn.innerHTML="Sending...";                    
     let MyFormData = new FormData();    
     MyFormData.append("email",email)  

     
     
     axios.post(AppURL.PostSubscribe, MyFormData)
    .then((response) => {

        console.log(response);

        if (response.status === 200 && response.data === 1) {
            toast.success("Email registered Successfully");
            sendBtn.innerHTML = "Subscribe";
            subscribeForm.reset();
        } else {
            toast.error("Error");
            sendBtn.innerHTML = "Subscribe";
        }

    })
    .catch((error) => {

        console.log(error.response);
        toast.error("Request Failed");
        sendBtn.innerHTML = "Subscribe";

    });


               }
               event.preventDefault();
          }

     render() {
          return (
               <Fragment>                          
 <div style={{ background: "#0d6efd", color: "#fff", padding: "60px 0" }}>
      <Container>
 <Row className="align-items-center">
              
          {/* LEFT TEXT */}
          <Col md={6}>
            <h2 className="fw-bold">
              Subscribe to Our Newsletter
            </h2>

            <p className="mb-0">
              Stay updated with our latest software, updates, and offers.
              Subscribe to access more.
            </p>
          </Col>
       {/* RIGHT FORM */}
          <Col md={6}>            
              <Form id="subscribeForm" onSubmit={this.onFormSubmit} className="d-flex mt-3 mt-md-0">

     <input onChange={this.emailOnChange} className="form-control m-2" type="email" placeholder="Enter Email"
/>
              <Button id="sendBtn"  type="submit" variant="light"  style={{borderRadius: "30px",
                  fontWeight: "bold"
                }}
              >
                Subscribe
              </Button>

            </Form>
          </Col>



         
     
  
                
     
     
     
     
     
     
                        
                    </Row>
               </Container>
               </div>
                <ToastContainer />
          </Fragment>
          )
     }
}

export default NewsletterSubscribe